import { render, staticRenderFns } from "./UplinkList.vue?vue&type=template&id=366940c0&scoped=true"
import script from "./UplinkList.vue?vue&type=script&lang=js"
export * from "./UplinkList.vue?vue&type=script&lang=js"
import style0 from "./UplinkList.vue?vue&type=style&index=0&id=366940c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366940c0",
  null
  
)

export default component.exports